export default __webpack_public_path__ + "static/media/acceso_vascular_insercion_periferica.960394a5.pdf";